import { useQuery } from "@tanstack/react-query";

import { getWinProbabilityAccuracy } from "@/api/coupons";
import { CouponsQueryKeys } from "./couponsQueryKeys";

// The report aggregates settled coupons, so it changes slowly: fetched only
// while the panel is open, kept fresh for 5 minutes, never polled.
const WIN_PROBABILITY_ACCURACY_STALE_MS = 5 * 60 * 1000;

interface UseWinProbabilityAccuracyOptions {
  days: number;
  enabled: boolean;
}

export const useWinProbabilityAccuracy = ({
  days,
  enabled,
}: UseWinProbabilityAccuracyOptions) =>
  useQuery({
    queryKey: [CouponsQueryKeys.WinProbabilityAccuracy, days],
    enabled,
    staleTime: WIN_PROBABILITY_ACCURACY_STALE_MS,
    queryFn: ({ signal }) =>
      getWinProbabilityAccuracy({ signal, params: { days } }),
  });
